import * as React from "react";
import numeral from "numeral";
import CountUp from "react-countup";

const formatNumber = (num: number): string => {
  const withDecimals = num >= 100000;
  return numeral(num)
    .format(withDecimals ? "0a" : "0,0")
    .toUpperCase();
};

export const countUp = (num: number): React.ReactElement => {
  return <CountUp formattingFn={formatNumber} end={num} duration={3} />;
};
